import { View } from '@/modules/main';
import { start } from 'reaux-dom';

start({ Component: View, container: document.getElementById('app-root') as HTMLDivElement });
